import * as Sentry from '@sentry/react';
import { config } from './config';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';
import { useEffect } from 'react';

export function initSentry() {
  if (!config.sentry.dsn) {
    return;
  }

  Sentry.init({
    dsn: config.sentry.dsn,
    environment: config.sentry.environment,
    release: `${config.app.name}@${config.app.version}`,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
      Sentry.httpClientIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: config.env.isProduction ? 0.2 : 1.0,
    // Session Replay
    replaysSessionSampleRate: config.env.isProduction ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
    // Only send errors in non-development environments
    enabled: true,
    // Filter out noisy or irrelevant errors
    ignoreErrors: [
      'ResizeObserver loop',
      'Network Error',
      'Load failed',
      'ChunkLoadError',
    ],
    // Attach request/response bodies for API error context
    sendDefaultPii: false,
  });
}
